import script from "./InfoGarantias.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoGarantias.vue?vue&type=script&setup=true&lang=js"

import "./InfoGarantias.vue?vue&type=style&index=0&id=56733f7e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56733f7e"]])

export default __exports__